import React, { useLayoutEffect } from "react";
import { useWindowSize } from "../../contexts";
import { getCompanyCodeParam } from "../../contexts/functions";
import { COMPANY_CODES } from "../../constants/configCompany";
import "./ServiceEndedScreen.scss";

function ServiceEndedScreen() {
  const [, windowHeight] = useWindowSize();
  const companyCode = getCompanyCodeParam();

  useLayoutEffect(() => {
    document.documentElement.style.setProperty(
      "--dynamic-vh",
      `${windowHeight * 0.01}px`
    );

    const pageBody = document.getElementById("page-body");
    document.documentElement.style.setProperty(
      "--page-body-offset-top",
      `${pageBody?.offsetTop}px`
    );
  }, [windowHeight]);

  const getServiceEndedMessage = () => {
    if (companyCode === COMPANY_CODES.MARUETSU) {
      return (
        <>
          マルエツプライムサービスの新規受け付けは
          <br />
          2025年10月31日をもちまして、終了いたしました。
        </>
      );
    }
    if (companyCode === COMPANY_CODES.MAX_VALUE) {
      return (
        <>
          MV関東プライムサービスの新規受け付けは
          <br />
          2025年12月9日をもちまして、終了いたしました。
        </>
      );
    }
    return '';
  };

  return (
    <div className="screen-container">
      <div className="service-ended-screen">
        <h1 className="service-end-title">サービス終了のお知らせ</h1>
        <div className="service-end-message">
          <p className="main-message">
            {getServiceEndedMessage()}
          </p>
          <p className="sub-message">ご利用ありがとうございました。</p>
        </div>
      </div>
    </div>
  );
}

export default ServiceEndedScreen;
